<template>
  <div class="p-6">
    <div class="mb-4">
      <h3 class="text-lg font-semibold mb-2">פרטי המועמד</h3>
      <div class="bg-gray-50 p-3 rounded">
        <p><strong>שם:</strong> {{ offer.applicant && offer.applicant.first_name }} {{ offer.applicant && offer.applicant.last_name }}</p>
        <p><strong>אימייל:</strong> {{ offer.applicant && offer.applicant.email }}</p>
      </div>
    </div>

    <div class="mb-4">
      <h3 class="text-lg font-semibold mb-2">פרטי המשרה</h3>
      <div class="bg-gray-50 p-3 rounded">
        <p><strong>תפקיד:</strong> {{ offer.position && offer.position.title }}</p>
        <p><strong>חברה:</strong> {{ offer.position && offer.position.company && offer.position.company.name }}</p>
      </div>
    </div>

    <div class="mb-6">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        בחר איש קשר בחברה
      </label>
      <select
        v-model="selectedEmployeeId"
        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        required
      >
        <option value="">בחר איש קשר...</option>
        <option
          v-for="employee in companyEmployees"
          :key="employee.id"
          :value="employee.id"
        >
          {{ employee.user && employee.user.first_name }} {{ employee.user && employee.user.last_name }} - {{ employee.user && employee.user.email }}
        </option>
      </select>
    </div>

    <div class="mb-6">
      <button
        @click="openAddEmployeeModal"
        class="text-blue-600 hover:text-blue-800 text-sm"
      >
        + הוסף איש קשר חדש
      </button>
    </div>

    <div class="flex justify-end gap-3">
      <button
        @click="closeModal"
        class="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
      >
        ביטול
      </button>
      <button
        @click="exposeOffer"
        :disabled="!selectedEmployeeId || isExposing"
        class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
      >
        {{ isExposing ? 'חושף...' : 'חשף הצעה' }}
      </button>
    </div>
  </div>
</template>

<script>
import NetworkUtils from '@/custom/classes/network_utils.js'
import { emit } from '@/custom/classes/my_utils.js'
import { mapMutations } from 'vuex'

export default {
  name: 'OfferExposureModal',
  props: {
    payload: {
      type: Object,
      required: true
    },
    updateTitle: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      selectedEmployeeId: '',
      companyEmployees: [],
      isExposing: false,
      networkUtils: new NetworkUtils()
    }
  },
  computed: {
    offer () {
      return (this.payload.props && this.payload.props.offer) || {}
    },
    selectedFiles () {
      return (this.payload.props && this.payload.props.selectedFiles) || []
    },
    exposureEmailText () {
      return (this.payload.props && this.payload.props.exposureEmailText) || ''
    }
  },
  mounted () {
    console.log('OfferExposureModal mounted with payload:', this.payload)
    console.log('Offer data:', this.offer)

    if (this.offer && this.offer.position && this.offer.position.company && this.offer.position.company.id) {
      this.loadCompanyEmployees()
    } else {
      console.error('Missing company ID in offer data:', this.offer)
    }
    // Update modal title
    this.updateTitle('חשיפת הצעה')
  },
  methods: {
    async loadCompanyEmployees () {
      try {
        console.log('Loading company employees for company ID:', this.offer.position.company.id)
        const response = await this.networkUtils.getCompanyEmployees({
          company_id: this.offer.position.company.id
        })
        console.log('Company employees response:', response)
        this.companyEmployees = response || []
      } catch (error) {
        console.error('Error loading company employees:', error)
        emit('show_toast', { text: 'שגיאה בטעינת אנשי הקשר', type: 'error' })
      }
    },

    openAddEmployeeModal () {
      this.create({
        designator: 'add-company-employee-from-exposure',
        component_name: 'CompanyEmployeesForm',
        modal_title: 'הוסף איש קשר חדש',
        modal_width: 600,
        company_id: this.offer.position.company.id,
        employee: null,
        onSave: () => this.loadCompanyEmployees()
      })
    },

    async exposeOffer () {
      if (!this.selectedEmployeeId) return

      this.isExposing = true
      try {
        console.log('Exposing offer with params:', {
          offer_id: this.offer.id,
          company_employee_id: this.selectedEmployeeId
        })

        const response = await this.networkUtils.exposeOffer({
          offer_id: this.offer.id,
          company_employee_id: this.selectedEmployeeId,
          owner: 'Admin', // Add owner parameter as expected by the controller
          selected_files: this.selectedFiles, // Pass selected files to backend
          text: this.exposureEmailText
        })

        console.log('Expose offer response:', response)

        if (response.success) {
          emit('show_toast', {
            text: `הצעה נחשפה בהצלחה ל-${response.company_employee.name}`,
            type: 'success'
          })

          // Emit exposed event if callback exists
          if (this.payload.props && this.payload.props.onExposed) {
            this.payload.props.onExposed(response)
          }

          this.closeModal()
        } else {
          emit('show_toast', { text: response.message || 'שגיאה בחשיפת ההצעה', type: 'error' })
        }
      } catch (error) {
        console.error('Error exposing offer:', error)
        emit('show_toast', { text: 'שגיאה בחשיפת ההצעה', type: 'error' })
      } finally {
        this.isExposing = false
      }
    },

    closeModal () {
      this.remove(this.payload)
    },

    ...mapMutations('modals', ['create', 'remove'])
  }
}
</script>
